module.exports = __webpack_public_path__ + "media/images/logo_rect-47fe6a33de254857d39a4eebe2904a64.png";